export function HexagonMark({ size = 34, dark = false }) {
    return (
        <svg
            width={size}
            height={(size * 38) / 34}
            viewBox="0 0 34 38"
            aria-hidden="true"
        >
            <path
                d="M17 1.5 31.5 9.75v18.5L17 36.5 2.5 28.25V9.75Z"
                fill={dark ? "#FFFFFF" : "#0B1630"}
            />
            <path
                d="M17 8.5 25.5 13.3v9.9L17 28 8.5 23.2v-9.9Z"
                fill="none"
                stroke="#C8A96B"
                strokeWidth="1.6"
            />
            <path
                d="M12.5 14.5v9M21.5 14.5v9M12.5 19h9"
                stroke={dark ? "#0B1630" : "#FFFFFF"}
                strokeWidth="1.9"
                strokeLinecap="round"
            />
        </svg>
    );
}

export default function Logo({ dark = false }) {
    return (
        <span className="flex items-center gap-2.5" data-testid="brand-logo">
            <HexagonMark dark={dark} />
            <span
                className={`font-display font-extrabold tracking-tight text-lg leading-none ${
                    dark ? "text-white" : "text-navy"
                }`}
            >
                HEXAGON
                <span className="block text-[10px] font-bold tracking-[0.38em] text-gold mt-0.5">
                    EOR
                </span>
            </span>
        </span>
    );
}
